import Icon from '../components/Icon.vue'

Icon.register({"asterisk":{"width":512,"height":512,"paths":[{"d":"M478.2 334.1L336 256 478.2 177.9C490 171.4 494.2 156.5 487.4 144.9L468 111.1C461.2 99.5 446.2 95.6 434.7 102.6L296 186.7 299.5 24.5C299.8 11.1 288.9 0 275.5 0H236.5C223.1 0 212.2 11.1 212.5 24.5L216 186.7 77.3 102.6C65.8 95.6 50.8 99.5 44 111.1L24.6 144.9C17.8 156.5 22 171.4 33.8 177.9L176 256 33.8 334.1C22 340.6 17.8 355.5 24.6 367.1L44 400.9C50.8 412.5 65.8 416.4 77.3 409.4L216 325.3 212.5 487.5C212.2 500.9 223.1 512 236.5 512H275.5C288.9 512 299.8 500.9 299.5 487.5L296 325.3 434.7 409.4C446.2 416.4 461.2 412.5 468 400.9L487.4 367.1C494.2 355.5 490 340.6 478.2 334.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/asterisk.js
// module id = jRS6
// module chunks = 0